var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-initial-access"},[_c('MoleculeInitialAccess')],1)}
var staticRenderFns = []

export { render, staticRenderFns }